"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooManyValuationErrorHandlerDefinition = void 0;
const ErrorHandlerPlugin_1 = require("auto-widget-framework/src/Plugin/ErrorHandler/ErrorHandlerPlugin");
const ErrorHandlerPluginDefinition_1 = require("auto-widget-framework/src/Plugin/ErrorHandler/ErrorHandlerPluginDefinition");
const StepTypes_1 = require("../../../../Enum/StepTypes");
const TooManyValuationError_1 = require("../../../../Error/TooManyValuationError");
class TooManyValuationErrorHandler extends ErrorHandlerPlugin_1.default {
    /**
    * @inheritDoc
    */
    handle(error, widget) {
        return Promise.resolve().then(() => {
            if (!TooManyValuationError_1.default.is(error)) {
                return false;
            }
            return widget.setStep(StepTypes_1.StepTypes.RESTRICTED_VALUATION)
                .then(() => true);
        });
    }
}
exports.default = TooManyValuationErrorHandler;
exports.TooManyValuationErrorHandlerDefinition = new ErrorHandlerPluginDefinition_1.default({
    class: TooManyValuationErrorHandler,
    id: "too_many_valuation",
    priority: 0
});
